<template>
    <div id="app">
        <main-header nowtab="play"></main-header>
        <main v-if="tower" class="adjuster">
            <info-board :tower="tower" />
            <rating-board v-bind="rating" />
            <record-board :record="record" :competition="tower.competition > 0" />
            <comment-board :comments="comments" />
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import InfoBoard from './panels/InfoBoard.vue'
import RecordBoard from './panels/RecordBoard.vue'
import RatingBoard from './panels/RatingBoard.vue'
import CommentBoard from './panels/CommentBoard.vue'
import { getSSRdata } from '../../utils/utils'

export default {
    data: () => ({
        tower: null,
        record: null,
        rating: null,
        myrate: null,
        focused: false,
        canComment: false,
        comments: null,
    }),
    provide() {
        return {
            app: this,
        }
    },
    created() {
        const { tower, record, rating, focused, canComment, comments } = getSSRdata('tower');
        document.title = `${ tower.title } - 作品主页 - HTML5魔塔广场`;
        this.tower = tower;
        this.record = record;
        this.rating = rating;
        this.focused = focused;
        this.canComment = canComment;
        this.comments = comments;
    },
    components: {
        MainHeader, Footer,
        InfoBoard,
        RatingBoard,
        RecordBoard,
        CommentBoard,
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
    div {
        margin-bottom: 30px;
    }
}
</style>